import { render, staticRenderFns } from "./MyVehicleType.vue?vue&type=template&id=364b845c&scoped=true"
import script from "./MyVehicleType.vue?vue&type=script&lang=js"
export * from "./MyVehicleType.vue?vue&type=script&lang=js"
import style0 from "./MyVehicleType.vue?vue&type=style&index=0&id=364b845c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b845c",
  null
  
)

export default component.exports